import React from 'react';

function MainTypingText(){
  return (
    <p className="typing">Hey! I'm Chaya.</p>
  );
}

export default MainTypingText;